import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

const Certificates = () => {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(null);

  const certificates = [
    {
      key: 'certificate0',
      image: '/certificates/Cert1.jpg',
      title: t('certificate0Title'),
      desc: t('certificate0Desc'),
    },
    {
      key: 'certificate1',
      image: '/certificates/Cert2.jpg',
      title: t('certificate1Title'),
      desc: t('certificate1Desc'),
    },
    {
      key: 'certificate2',
      image: '/certificates/Cert3.jpg',
      title: t('certificate2Title'),
      desc: t('certificate2Desc'),
    },
  ];

  return (
    <>
      <Helmet>
        <title>Infinity Energy Solar – Certificates</title>
      </Helmet>
      <div className="pt-24 pb-16 px-6 text-[#173861] relative">
        <h1 className="text-4xl font-bold text-center mb-6">{t('certificatesHero')}</h1>
        <p className="text-center max-w-2xl mx-auto text-lg mb-12">{t('certificatesIntro')}</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {certificates.map((certificate) => (
            <div
              key={certificate.key}
              className="group relative overflow-hidden rounded-xl bg-white shadow-md border border-green-600 hover:border-green-600 transition duration-300"
              onClick={() => setSelectedImage(certificate.image)}
            >
              <img
                src={certificate.image}
                alt={certificate.title}
                className="w-full h-64 object-cover transition duration-300 hover:scale-105"
              />
              <div className="p-6 text-center">
                <h2 className="text-2xl font-bold mb-2">{certificate.title}</h2>
                <p>{certificate.desc}</p>
              </div>
              <div className="absolute bottom-0 left-0 w-full h-2 bg-green-600"></div>
            </div>
          ))}
        </div>

        {selectedImage && (
          <div
            className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
            onClick={() => setSelectedImage(null)}
          >
            <img src={selectedImage} alt="Enlarged certificate" className="max-w-4xl max-h-[90vh] object-contain" />
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-6 right-6 text-white text-3xl font-bold"
            >
              &times;
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Certificates;
